import { Model } from 'vuex-orm';

import App from '../app/model';
import AppPackage from '../package/model';

export default class AppMembership extends Model {
  static entity = 'appMemberships';

  static fields() {
    return {
      id: this.attr(null),
      company_id: this.attr(null),
      app_id: this.attr(null),
      package_id: this.attr(null),
      active: this.attr(''),
      canceled_at: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),

      app: this.belongsTo(App, 'app_id'),
      package: this.belongsTo(AppPackage, 'package_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/appMembership/model.js